<mt-filter
    [filterConfig]="filterConfig"
    [progressBar]="filterConfig.isLoading"
    (filterChange)="getReportFrontData($event)"
></mt-filter>

<div
    class="report-container mt-4"
    *ngIf="tableConfig || message || systemError"
>
    <div class="header-container">
        <div class="header">
            <div class="float-left">
                <div class="title">
                    {{ "fronts-report" | lang | uppercase }}
                </div>
            </div>
            <div class="float-right" *ngIf="tableConfig">
                <app-button-icon
                    [image]="'download'"
                    [iconType]="'icon'"
                    [disabled]="disabledExcelBtn"
                    [spinner]="btnSpinner"
                    (clickHandler)="downloadExcelFile()"
                ></app-button-icon>
            </div>
        </div>
    </div>

    <div [ngClass]="{ 'body-container': tableConfig }">
        <!-- Message -->
        <div class="d-flex flex-row message" *ngIf="message">
            <img
                class="message-img"
                alt="mt-image"
                appImageSelector
                [imageType]="'icon'"
                [imageKey]="'error-red'"
            />
            <span class="message-text">{{ message }}</span>
        </div>

        <app-system-error-message
            *ngIf="!!systemError"
            [message]="systemError"
        ></app-system-error-message>

        <app-main-table
            cy-data="report-front-data"
            [tableConfig]="tableConfig"
            class="table-container"
            (sendInfoToComponent)="viewImage($event)"
        ></app-main-table>
    </div>
</div>
